import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'

export const $ModalContainer = styled.div`
  min-width: 500px;
`

export const $Container = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(3)};
`

export const $Paragraph = styled.p``

export const $List = styled.ul`
  padding-left: ${({ theme }) => theme.spacing(3)};
  li {
    padding: 2px 0;
    width: fit-content;
  }
`

export const $Description = styled.p`
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  margin-bottom: ${({theme}) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.text.disabled};
  font-size: 1.1em;
`

export const $LinkItem = styled.a`
`

export const $NavItem = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
